import React from 'react';
import { connect } from 'react-redux';

import { PATH } from '../../../../constants/path';
import { MY_EBONS_URL_REDIRECTION } from '../../../../constants';

import { sendEbonReminder, reset } from '../../../../services/ebonReminder/actions';

import { getI18nByApp } from '../../../../services/i18n/selector';

import { stringToMoment, toTimestamp } from '../../../../utils/dateUtils';
import { getUserId, getClickId } from '../../../../utils/plebicardUtils';
import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import {
    DateInputFieldComponent,
    EmailInputFieldComponent,
    FormComponent,
    LegendFieldComponent
} from '../../../form';
import HeadComponent from '../../../HeadComponent';
import { withTemplate } from '../../../template/withTemplate';
import { PrimaryTemplate } from '../../../template/PrimaryTemplate';
import LocalizedBreadcrumbItem from '../../../breadcrumb/LocalizedBreadcrumbsItem';

import { MyEbonsPageContainer } from './MyEbonsPageStyle';

export class MyEbonsPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            start: '',
            end: ''
        };
    }

    componentWillMount() {
        if (MY_EBONS_URL_REDIRECTION) {
            window.location.href = MY_EBONS_URL_REDIRECTION;
        }
    }

    submit = data => {
        const { sendEbonReminder, reset, userId } = this.props;

        if (!this.checkDateValues()) {
            this.setState({ email: data.email });

            const clickId = getClickId();
            const startDate = stringToMoment(data.start); // at 00h 00m 00s
            const endDate = stringToMoment(data.end).add(86399, 'seconds'); // at 23h 59m 59s
            data.start = toTimestamp(startDate);
            data.end = toTimestamp(endDate);

            const effectiveUserId = clickId ? clickId : userId ? userId : data.email;

            sendEbonReminder({ ...data, userId: effectiveUserId }, () => {
                setTimeout(() => {
                    reset();
                }, 5000);
            });
        }
    };

    handleOnChangeStartDate = e => {
        const value = e.target.value;
        this.setState({ start: value });
    };
    handleOnChangeEndDate = e => {
        const value = e.target.value;
        this.setState({ end: value });
    };
    checkDateValues = () => {
        const { i18nForm } = this.props;
        const { start, end } = this.state;

        if (start && end) {
            const startDate = stringToMoment(start);
            const endDate = stringToMoment(end);

            if (startDate.isAfter(endDate)) {
                return (
                    <p className="color-err message full">
                        {i18nForm.START_DATE_MUST_BE_AFTER_END_DATE}
                    </p>
                );
            } else if (endDate.diff(startDate, 'days') > 60) {
                return <p className="color-err message full">{i18nForm.MAX_PERIOD_REACHED}</p>;
            }
        }

        return null;
    };

    render() {
        const {
            i18n,
            i18nForm,
            i18nMulti,
            requestSubmit,
            successSubmit,
            errorSubmit,
            mailSent
        } = this.props;
        const { email } = this.state;

        const FORM_NAME = 'send-ebon-reminder-form';

        return (
            <MyEbonsPageContainer className="conteneur conteneur-mobile" id="p-my-ebons">
                <HeadComponent
                    title={getI18nByApp(i18nMulti, 'page.EBON_REMINDER.TITLE')}
                    description={i18n.DESCRIPTION}
                />
                <LocalizedBreadcrumbItem to={PATH.EBONS_REMINDER_PATH}>
                    {getI18nByApp(i18nMulti, 'page.EBON_REMINDER.TITLE')}
                </LocalizedBreadcrumbItem>
                <h1>{getI18nByApp(i18nMulti, 'page.EBON_REMINDER.TITLE')}</h1>

                <p>{getI18nByApp(i18nMulti, 'page.EBON_REMINDER.TEXT1')}</p>

                <FormComponent
                    form={FORM_NAME}
                    classNameInputContainer="grid-2 has-gutter"
                    onSubmit={this.submit}
                    requestSubmit={requestSubmit}
                    errorSubmit={!successSubmit}
                    submitText={i18n.BUTTON_VALIDATE}>
                    <EmailInputFieldComponent
                        name="email"
                        label={i18n.LABEL_EMAIL}
                        classNameInputContainer="one-half mr50"
                        isRequired
                    />
                    <DateInputFieldComponent
                        name="start"
                        label={i18n.LABEL_START_DATE}
                        classNameInputContainer="one-half"
                        isRequired
                        mustBeDatePast
                        onChange={this.handleOnChangeStartDate}
                    />
                    <DateInputFieldComponent
                        name="end"
                        label={i18n.LABEL_END_DATE}
                        classNameInputContainer="one-half"
                        isRequired
                        mustBeDatePast
                        onChange={this.handleOnChangeEndDate}
                    />

                    <React.Fragment>{this.checkDateValues()}</React.Fragment>

                    <LegendFieldComponent classNameInputContainer="full">
                        {i18nForm.MANDATORY_FIELD}
                    </LegendFieldComponent>

                    <React.Fragment>
                        {!successSubmit && errorSubmit && (
                            <LegendFieldComponent classNameInputContainer="color-err message full">
                                {errorSubmit}
                            </LegendFieldComponent>
                        )}
                        {successSubmit && !mailSent && (
                            <LegendFieldComponent classNameInputContainer="color-err message full">
                                {i18n.SUBMIT_FAILED}
                            </LegendFieldComponent>
                        )}
                        {successSubmit && mailSent && (
                            <LegendFieldComponent classNameInputContainer="color-succ form-success-message message full">
                                {convertHtmlToReactDomWithParams(
                                    getI18nByApp(i18nMulti, 'page.EBON_REMINDER.SUBMIT_SUCCEEDED'),
                                    email
                                )}
                            </LegendFieldComponent>
                        )}
                    </React.Fragment>
                </FormComponent>
            </MyEbonsPageContainer>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON_REMINDER,
        i18nMulti: state.i18n,
        i18nForm: state.i18n.feature.form,
        requestSubmit: state.ebonReminder.fetching || false,
        successSubmit: state.ebonReminder.successSubmit,
        errorSubmit: state.ebonReminder.error,
        mailSent: state.ebonReminder.mailSent,
        userId: getUserId(state)
    };
};

const mapDispatchtoProps = {
    sendEbonReminder,
    reset
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchtoProps)(MyEbonsPage),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/ebon/reminder/MyEbonsPage.js